import SideMenu from './SideMenu';


SideMenu.install = function(Vue) {
  Vue.component(SideMenu.name, SideMenu);
};

export default SideMenu;
